import { HomeAlert, HomeValueProp } from '../models/home.models';

export const HOME_ALERTS: HomeAlert[] = [
  {
    id: 'schedule',
    type: 'neutral',
    title: 'Schedule Updates',
    message: 'Some routes may have adjusted departure times during peak season.',
  },
  {
    id: 'weather',
    type: 'warning',
    title: 'Weather Advisories',
    message: 'Check travel advisories before booking trips to northern provinces.',
  },
];

export const HOME_VALUE_PROPS: HomeValueProp[] = [
  { id: 'safe', icon: 'shield', title: 'Safe Travel', subtitle: 'Certified safety standards' },
  { id: 'fleet', icon: 'bus', title: 'Modern Fleet', subtitle: 'Air-conditioned coaches' },
  { id: 'rating', icon: 'star', title: '4.8 Rating', subtitle: 'Trusted by travelers' },
  { id: 'ontime', icon: 'clock', title: 'On-Time', subtitle: 'Reliable departures' },
];

export const NAV_ITEMS = [
  'Home',
  'Travel Info',
  'Promos',
  "What's New",
  'My Trips',
] as const;

export const FOOTER_QUICK_LINKS = [
  'Schedules',
  'Terminals',
  'Promos',
  'Travel Info',
  'Contact Us',
] as const;
